import React, { useEffect } from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import KLPleaseWait from '../../KLPleaseWait';
import PhoneStep from '../PhoneStep';
import OtpStep from '../OtpStep';
import useSignInState from './useSignInState';
import {
  AuthModalBox,
  AuthModalHeader,
  AuthModalTitle,
  AuthModalSubtitle,
  AuthCloseButton,
} from '../KLBookingAuthModal/styles';

interface KLSignInModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const stepCopy: Record<string, { title: string; subtitle?: string }> = {
  phone: {
    title: 'ניהול תור קיים',
    subtitle: 'נשלח קוד אימות ב-SMS למספר שהזמנתם איתו.',
  },
  otp: {
    title: 'הזינו את הקוד שקיבלתם',
    subtitle: 'הקוד תקף ל-5 דקות.',
  },
  done: { title: 'מעבירים אתכם...' },
  error: { title: 'משהו השתבש' },
};

const KLSignInModal: React.FC<KLSignInModalProps> = ({ open, onClose, onSuccess }) => {
  const state = useSignInState();

  useEffect(() => {
    if (open && state.isDone) onSuccess();
  }, [open, state.isDone, onSuccess]);

  const copy = stepCopy[state.currentStep] ?? { title: '' };

  return (
    <Modal
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      disableEscapeKeyDown
      aria-labelledby="sign-in-modal"
    >
      <AuthModalBox>
        <AuthModalHeader>
          <AuthModalTitle id="sign-in-modal">{copy.title}</AuthModalTitle>
          <AuthCloseButton aria-label="סגור" onClick={onClose}>
            <CloseIcon />
          </AuthCloseButton>
        </AuthModalHeader>
        {copy.subtitle && <AuthModalSubtitle>{copy.subtitle}</AuthModalSubtitle>}

        {state.currentStep === 'phone' && (
          <PhoneStep
            onSubmit={state.onPhoneSubmit}
            isSubmitting={state.isSubmitting}
            error={state.error}
          />
        )}
        {state.currentStep === 'otp' && (
          <OtpStep
            onSubmit={state.onOtpSubmit}
            onResend={state.onResend}
            cooldownSeconds={state.cooldownSeconds}
            isSubmitting={state.isSubmitting}
            error={state.error}
          />
        )}
        {state.currentStep === 'done' && <KLPleaseWait text="מעבירים אתכם..." />}
        {state.currentStep === 'error' && (
          <div role="alert">{state.error || 'שגיאה לא צפויה. נסו שוב.'}</div>
        )}
      </AuthModalBox>
    </Modal>
  );
};

export default KLSignInModal;
